module.exports = __webpack_public_path__ + "img/gl.ec306dbd.svg";